'use strict';

var cov_2lmk0xa03k = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\modules\\http.js',
      hash = 'a3fb7d9688a58d87ba6e73c56e2737e512732cfc',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\modules\\http.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 16
        },
        end: {
          line: 1,
          column: 58
        }
      },
      '1': {
        start: {
          line: 2,
          column: 10
        },
        end: {
          line: 2,
          column: 57
        }
      },
      '2': {
        start: {
          line: 10,
          column: 0
        },
        end: {
          line: 10,
          column: 17
        }
      },
      '3': {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 11,
          column: 16
        }
      },
      '4': {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 232,
          column: 4
        }
      },
      '5': {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 14,
          column: 16
        }
      },
      '6': {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 21
        }
      },
      '7': {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 21
        }
      },
      '8': {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 17,
          column: 21
        }
      },
      '9': {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 18,
          column: 20
        }
      },
      '10': {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 29
        }
      },
      '11': {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 132,
          column: 4
        }
      },
      '12': {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 17
        }
      },
      '13': {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 22
        }
      },
      '14': {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 22
        }
      },
      '15': {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 22
        }
      },
      '16': {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 31,
          column: 21
        }
      },
      '17': {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 33
        }
      },
      '18': {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 34
        }
      },
      '19': {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 40,
          column: 48
        }
      },
      '20': {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 41
        }
      },
      '21': {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 40
        }
      },
      '22': {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 42
        }
      },
      '23': {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 45
        }
      },
      '24': {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 48
        }
      },
      '25': {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 62,
          column: 7
        }
      },
      '26': {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 61,
          column: 10
        }
      },
      '27': {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 67,
          column: 7
        }
      },
      '28': {
        start: {
          line: 64,
          column: 8
        },
        end: {
          line: 66,
          column: 10
        }
      },
      '29': {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 70,
          column: 7
        }
      },
      '30': {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 21
        }
      },
      '31': {
        start: {
          line: 71,
          column: 19
        },
        end: {
          line: 71,
          column: 42
        }
      },
      '32': {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 72,
          column: 46
        }
      },
      '33': {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 35
        }
      },
      '34': {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 35
        }
      },
      '35': {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 75,
          column: 35
        }
      },
      '36': {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 34
        }
      },
      '37': {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 31
        }
      },
      '38': {
        start: {
          line: 79,
          column: 23
        },
        end: {
          line: 79,
          column: 33
        }
      },
      '39': {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 80,
          column: 25
        }
      },
      '40': {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 91,
          column: 19
        }
      },
      '41': {
        start: {
          line: 83,
          column: 31
        },
        end: {
          line: 83,
          column: 44
        }
      },
      '42': {
        start: {
          line: 84,
          column: 18
        },
        end: {
          line: 87,
          column: 19
        }
      },
      '43': {
        start: {
          line: 85,
          column: 20
        },
        end: {
          line: 85,
          column: 45
        }
      },
      '44': {
        start: {
          line: 86,
          column: 20
        },
        end: {
          line: 86,
          column: 27
        }
      },
      '45': {
        start: {
          line: 88,
          column: 18
        },
        end: {
          line: 88,
          column: 40
        }
      },
      '46': {
        start: {
          line: 90,
          column: 18
        },
        end: {
          line: 90,
          column: 34
        }
      },
      '47': {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 92,
          column: 30
        }
      },
      '48': {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 99,
          column: 7
        }
      },
      '49': {
        start: {
          line: 96,
          column: 8
        },
        end: {
          line: 98,
          column: 1
        }
      },
      '50': {
        start: {
          line: 100,
          column: 6
        },
        end: {
          line: 104,
          column: 7
        }
      },
      '51': {
        start: {
          line: 101,
          column: 8
        },
        end: {
          line: 103,
          column: 1
        }
      },
      '52': {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 107,
          column: 7
        }
      },
      '53': {
        start: {
          line: 106,
          column: 8
        },
        end: {
          line: 106,
          column: 21
        }
      },
      '54': {
        start: {
          line: 108,
          column: 19
        },
        end: {
          line: 108,
          column: 42
        }
      },
      '55': {
        start: {
          line: 109,
          column: 6
        },
        end: {
          line: 109,
          column: 46
        }
      },
      '56': {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 110,
          column: 35
        }
      },
      '57': {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 35
        }
      },
      '58': {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 112,
          column: 35
        }
      },
      '59': {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 113,
          column: 34
        }
      },
      '60': {
        start: {
          line: 115,
          column: 23
        },
        end: {
          line: 115,
          column: 33
        }
      },
      '61': {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 129,
          column: 9
        }
      },
      '62': {
        start: {
          line: 121,
          column: 21
        },
        end: {
          line: 121,
          column: 34
        }
      },
      '63': {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 125,
          column: 9
        }
      },
      '64': {
        start: {
          line: 123,
          column: 10
        },
        end: {
          line: 123,
          column: 35
        }
      },
      '65': {
        start: {
          line: 124,
          column: 10
        },
        end: {
          line: 124,
          column: 17
        }
      },
      '66': {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 126,
          column: 30
        }
      },
      '67': {
        start: {
          line: 128,
          column: 8
        },
        end: {
          line: 128,
          column: 24
        }
      },
      '68': {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 130,
          column: 30
        }
      },
      '69': {
        start: {
          line: 135,
          column: 2
        },
        end: {
          line: 176,
          column: 4
        }
      },
      '70': {
        start: {
          line: 137,
          column: 23
        },
        end: {
          line: 137,
          column: 41
        }
      },
      '71': {
        start: {
          line: 138,
          column: 6
        },
        end: {
          line: 138,
          column: 27
        }
      },
      '72': {
        start: {
          line: 139,
          column: 6
        },
        end: {
          line: 139,
          column: 62
        }
      },
      '73': {
        start: {
          line: 142,
          column: 23
        },
        end: {
          line: 142,
          column: 41
        }
      },
      '74': {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 143,
          column: 27
        }
      },
      '75': {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 58
        }
      },
      '76': {
        start: {
          line: 147,
          column: 23
        },
        end: {
          line: 147,
          column: 41
        }
      },
      '77': {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 27
        }
      },
      '78': {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 149,
          column: 58
        }
      },
      '79': {
        start: {
          line: 152,
          column: 23
        },
        end: {
          line: 152,
          column: 41
        }
      },
      '80': {
        start: {
          line: 153,
          column: 6
        },
        end: {
          line: 153,
          column: 27
        }
      },
      '81': {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 154,
          column: 58
        }
      },
      '82': {
        start: {
          line: 157,
          column: 6
        },
        end: {
          line: 157,
          column: 17
        }
      },
      '83': {
        start: {
          line: 160,
          column: 6
        },
        end: {
          line: 168,
          column: 7
        }
      },
      '84': {
        start: {
          line: 161,
          column: 24
        },
        end: {
          line: 161,
          column: 26
        }
      },
      '85': {
        start: {
          line: 162,
          column: 8
        },
        end: {
          line: 162,
          column: 43
        }
      },
      '86': {
        start: {
          line: 163,
          column: 8
        },
        end: {
          line: 163,
          column: 43
        }
      },
      '87': {
        start: {
          line: 164,
          column: 8
        },
        end: {
          line: 164,
          column: 43
        }
      },
      '88': {
        start: {
          line: 165,
          column: 8
        },
        end: {
          line: 165,
          column: 42
        }
      },
      '89': {
        start: {
          line: 166,
          column: 8
        },
        end: {
          line: 166,
          column: 31
        }
      },
      '90': {
        start: {
          line: 167,
          column: 8
        },
        end: {
          line: 167,
          column: 23
        }
      },
      '91': {
        start: {
          line: 170,
          column: 6
        },
        end: {
          line: 170,
          column: 162
        }
      },
      '92': {
        start: {
          line: 173,
          column: 6
        },
        end: {
          line: 173,
          column: 23
        }
      },
      '93': {
        start: {
          line: 179,
          column: 2
        },
        end: {
          line: 190,
          column: 4
        }
      },
      '94': {
        start: {
          line: 181,
          column: 23
        },
        end: {
          line: 181,
          column: 41
        }
      },
      '95': {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 27
        }
      },
      '96': {
        start: {
          line: 183,
          column: 6
        },
        end: {
          line: 183,
          column: 62
        }
      },
      '97': {
        start: {
          line: 186,
          column: 23
        },
        end: {
          line: 186,
          column: 41
        }
      },
      '98': {
        start: {
          line: 187,
          column: 6
        },
        end: {
          line: 187,
          column: 27
        }
      },
      '99': {
        start: {
          line: 188,
          column: 6
        },
        end: {
          line: 188,
          column: 58
        }
      },
      '100': {
        start: {
          line: 193,
          column: 2
        },
        end: {
          line: 193,
          column: 57
        }
      },
      '101': {
        start: {
          line: 194,
          column: 2
        },
        end: {
          line: 231,
          column: 4
        }
      },
      '102': {
        start: {
          line: 196,
          column: 6
        },
        end: {
          line: 196,
          column: 29
        }
      },
      '103': {
        start: {
          line: 199,
          column: 23
        },
        end: {
          line: 199,
          column: 40
        }
      },
      '104': {
        start: {
          line: 200,
          column: 18
        },
        end: {
          line: 200,
          column: 54
        }
      },
      '105': {
        start: {
          line: 201,
          column: 6
        },
        end: {
          line: 207,
          column: 7
        }
      },
      '106': {
        start: {
          line: 202,
          column: 8
        },
        end: {
          line: 202,
          column: 55
        }
      },
      '107': {
        start: {
          line: 203,
          column: 8
        },
        end: {
          line: 206,
          column: 9
        }
      },
      '108': {
        start: {
          line: 204,
          column: 10
        },
        end: {
          line: 204,
          column: 55
        }
      },
      '109': {
        start: {
          line: 205,
          column: 10
        },
        end: {
          line: 205,
          column: 56
        }
      },
      '110': {
        start: {
          line: 208,
          column: 6
        },
        end: {
          line: 208,
          column: 30
        }
      },
      '111': {
        start: {
          line: 209,
          column: 6
        },
        end: {
          line: 209,
          column: 21
        }
      },
      '112': {
        start: {
          line: 210,
          column: 6
        },
        end: {
          line: 210,
          column: 33
        }
      },
      '113': {
        start: {
          line: 211,
          column: 6
        },
        end: {
          line: 211,
          column: 51
        }
      },
      '114': {
        start: {
          line: 214,
          column: 23
        },
        end: {
          line: 214,
          column: 40
        }
      },
      '115': {
        start: {
          line: 215,
          column: 6
        },
        end: {
          line: 217,
          column: 7
        }
      },
      '116': {
        start: {
          line: 216,
          column: 8
        },
        end: {
          line: 216,
          column: 15
        }
      },
      '117': {
        start: {
          line: 219,
          column: 6
        },
        end: {
          line: 219,
          column: 22
        }
      },
      '118': {
        start: {
          line: 220,
          column: 6
        },
        end: {
          line: 220,
          column: 33
        }
      },
      '119': {
        start: {
          line: 221,
          column: 6
        },
        end: {
          line: 221,
          column: 50
        }
      },
      '120': {
        start: {
          line: 224,
          column: 23
        },
        end: {
          line: 224,
          column: 40
        }
      },
      '121': {
        start: {
          line: 225,
          column: 6
        },
        end: {
          line: 227,
          column: 7
        }
      },
      '122': {
        start: {
          line: 226,
          column: 8
        },
        end: {
          line: 226,
          column: 15
        }
      },
      '123': {
        start: {
          line: 228,
          column: 6
        },
        end: {
          line: 228,
          column: 26
        }
      },
      '124': {
        start: {
          line: 229,
          column: 6
        },
        end: {
          line: 229,
          column: 44
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 13,
            column: 52
          },
          end: {
            line: 13,
            column: 53
          }
        },
        loc: {
          start: {
            line: 13,
            column: 84
          },
          end: {
            line: 133,
            column: 1
          }
        },
        line: 13
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 59,
            column: 26
          },
          end: {
            line: 59,
            column: 27
          }
        },
        loc: {
          start: {
            line: 59,
            column: 42
          },
          end: {
            line: 61,
            column: 9
          }
        },
        line: 59
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 64,
            column: 24
          },
          end: {
            line: 64,
            column: 25
          }
        },
        loc: {
          start: {
            line: 64,
            column: 39
          },
          end: {
            line: 66,
            column: 9
          }
        },
        line: 64
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 82,
            column: 22
          },
          end: {
            line: 82,
            column: 23
          }
        },
        loc: {
          start: {
            line: 82,
            column: 34
          },
          end: {
            line: 89,
            column: 17
          }
        },
        line: 82
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 89,
            column: 19
          },
          end: {
            line: 89,
            column: 20
          }
        },
        loc: {
          start: {
            line: 89,
            column: 25
          },
          end: {
            line: 91,
            column: 17
          }
        },
        line: 89
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 96,
            column: 26
          },
          end: {
            line: 96,
            column: 27
          }
        },
        loc: {
          start: {
            line: 96,
            column: 42
          },
          end: {
            line: 97,
            column: 9
          }
        },
        line: 96
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 101,
            column: 24
          },
          end: {
            line: 101,
            column: 25
          }
        },
        loc: {
          start: {
            line: 101,
            column: 36
          },
          end: {
            line: 102,
            column: 9
          }
        },
        line: 101
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 120,
            column: 14
          },
          end: {
            line: 120,
            column: 15
          }
        },
        loc: {
          start: {
            line: 120,
            column: 26
          },
          end: {
            line: 127,
            column: 7
          }
        },
        line: 120
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 127,
            column: 9
          },
          end: {
            line: 127,
            column: 10
          }
        },
        loc: {
          start: {
            line: 127,
            column: 15
          },
          end: {
            line: 129,
            column: 7
          }
        },
        line: 127
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 134,
            column: 40
          },
          end: {
            line: 134,
            column: 41
          }
        },
        loc: {
          start: {
            line: 134,
            column: 62
          },
          end: {
            line: 177,
            column: 1
          }
        },
        line: 134
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 178,
            column: 45
          },
          end: {
            line: 178,
            column: 46
          }
        },
        loc: {
          start: {
            line: 178,
            column: 67
          },
          end: {
            line: 191,
            column: 1
          }
        },
        line: 178
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 192,
            column: 41
          },
          end: {
            line: 192,
            column: 42
          }
        },
        loc: {
          start: {
            line: 192,
            column: 63
          },
          end: {
            line: 232,
            column: 1
          }
        },
        line: 192
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        }, {
          start: {
            line: 58,
            column: 6
          },
          end: {
            line: 62,
            column: 7
          }
        }],
        line: 58
      },
      '1': {
        loc: {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        }, {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 67,
            column: 7
          }
        }],
        line: 63
      },
      '2': {
        loc: {
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 70,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 70,
            column: 7
          }
        }, {
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 70,
            column: 7
          }
        }],
        line: 68
      },
      '3': {
        loc: {
          start: {
            line: 71,
            column: 20
          },
          end: {
            line: 71,
            column: 30
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 71,
            column: 20
          },
          end: {
            line: 71,
            column: 24
          }
        }, {
          start: {
            line: 71,
            column: 28
          },
          end: {
            line: 71,
            column: 30
          }
        }],
        line: 71
      },
      '4': {
        loc: {
          start: {
            line: 84,
            column: 18
          },
          end: {
            line: 87,
            column: 19
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 84,
            column: 18
          },
          end: {
            line: 87,
            column: 19
          }
        }, {
          start: {
            line: 84,
            column: 18
          },
          end: {
            line: 87,
            column: 19
          }
        }],
        line: 84
      },
      '5': {
        loc: {
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 99,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 99,
            column: 7
          }
        }, {
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 99,
            column: 7
          }
        }],
        line: 95
      },
      '6': {
        loc: {
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 104,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 104,
            column: 7
          }
        }, {
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 104,
            column: 7
          }
        }],
        line: 100
      },
      '7': {
        loc: {
          start: {
            line: 105,
            column: 6
          },
          end: {
            line: 107,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 105,
            column: 6
          },
          end: {
            line: 107,
            column: 7
          }
        }, {
          start: {
            line: 105,
            column: 6
          },
          end: {
            line: 107,
            column: 7
          }
        }],
        line: 105
      },
      '8': {
        loc: {
          start: {
            line: 108,
            column: 20
          },
          end: {
            line: 108,
            column: 30
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 108,
            column: 20
          },
          end: {
            line: 108,
            column: 24
          }
        }, {
          start: {
            line: 108,
            column: 28
          },
          end: {
            line: 108,
            column: 30
          }
        }],
        line: 108
      },
      '9': {
        loc: {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 125,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 125,
            column: 9
          }
        }, {
          start: {
            line: 122,
            column: 8
          },
          end: {
            line: 125,
            column: 9
          }
        }],
        line: 122
      },
      '10': {
        loc: {
          start: {
            line: 160,
            column: 6
          },
          end: {
            line: 168,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 160,
            column: 6
          },
          end: {
            line: 168,
            column: 7
          }
        }, {
          start: {
            line: 160,
            column: 6
          },
          end: {
            line: 168,
            column: 7
          }
        }],
        line: 160
      },
      '11': {
        loc: {
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 207,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 207,
            column: 7
          }
        }, {
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 207,
            column: 7
          }
        }],
        line: 201
      },
      '12': {
        loc: {
          start: {
            line: 203,
            column: 8
          },
          end: {
            line: 206,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 203,
            column: 8
          },
          end: {
            line: 206,
            column: 9
          }
        }, {
          start: {
            line: 203,
            column: 8
          },
          end: {
            line: 206,
            column: 9
          }
        }],
        line: 203
      },
      '13': {
        loc: {
          start: {
            line: 215,
            column: 6
          },
          end: {
            line: 217,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 215,
            column: 6
          },
          end: {
            line: 217,
            column: 7
          }
        }, {
          start: {
            line: 215,
            column: 6
          },
          end: {
            line: 217,
            column: 7
          }
        }],
        line: 215
      },
      '14': {
        loc: {
          start: {
            line: 225,
            column: 6
          },
          end: {
            line: 227,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 225,
            column: 6
          },
          end: {
            line: 227,
            column: 7
          }
        }, {
          start: {
            line: 225,
            column: 6
          },
          end: {
            line: 227,
            column: 7
          }
        }],
        line: 225
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var URLSERVER = (cov_2lmk0xa03k.s[0]++, 'http://127.0.0.1:7070/delta_web_service/');
var URL = (cov_2lmk0xa03k.s[1]++, 'http://127.0.0.1:7070/delta_web_service/data/');

// URLSERVER="http://192.168.1.45/delta_web_service/";
// URL="http://192.168.1.45/delta_web_service/data/";

// URLSERVER="http://delta-suivi-evaluation.com/new_interface/";
// URL="http://delta-suivi-evaluation.com/new_interface/data/";

cov_2lmk0xa03k.s[2]++;
URLSERVER = './';
cov_2lmk0xa03k.s[3]++;
URL = './data/';
cov_2lmk0xa03k.s[4]++;
angular.module('delaHttp', []).factory('$deltahttp', ['$http', '$q', '$location', function ($http, $q, $location) {
  cov_2lmk0xa03k.f[0]++;
  cov_2lmk0xa03k.s[5]++;

  this.text = 1;
  cov_2lmk0xa03k.s[6]++;
  this.idUser = null;
  cov_2lmk0xa03k.s[7]++;
  this.espace = null;
  cov_2lmk0xa03k.s[8]++;
  this.projet = null;
  cov_2lmk0xa03k.s[9]++;
  this.admin = null;

  cov_2lmk0xa03k.s[10]++;
  this.USER_REPOSITORY = URL;
  cov_2lmk0xa03k.s[11]++;
  return {
    get_data_folder: function get_data_folder(params) {
      cov_2lmk0xa03k.s[12]++;

      return URL;
    },
    setUE: function setUE(u, e) {
      cov_2lmk0xa03k.s[13]++;

      this.idUser = u;
      cov_2lmk0xa03k.s[14]++;
      this.espace = e;
    },
    setPA: function setPA(p, a) {
      cov_2lmk0xa03k.s[15]++;

      this.projet = p;
      cov_2lmk0xa03k.s[16]++;
      this.admin = a;
    },
    isProjectSelected: function isProjectSelected() {
      cov_2lmk0xa03k.s[17]++;

      return this.projet != null;
    },
    getProjectRespositoy: function getProjectRespositoy() {
      cov_2lmk0xa03k.s[18]++;

      return URLSERVER + 'p_img/';
    },
    getUserRespositoy: function getUserRespositoy() {
      cov_2lmk0xa03k.s[19]++;

      return URLSERVER + 'UtilisateurPictures/';
    },
    getActorsRespositoy: function getActorsRespositoy() {
      cov_2lmk0xa03k.s[20]++;

      return URLSERVER + 'userPictures/';
    },
    getphotolibrary: function getphotolibrary() {
      cov_2lmk0xa03k.s[21]++;

      return URLSERVER + 'phototheque/';
    },
    getIndicatorRespositoy: function getIndicatorRespositoy() {
      cov_2lmk0xa03k.s[22]++;

      return URLSERVER + 'indicator_img/';
    },
    getIndicatorRespositoryLegend: function getIndicatorRespositoryLegend() {
      cov_2lmk0xa03k.s[23]++;

      return URLSERVER + 'indicator_legend/';
    },
    getUserPicture: function getUserPicture() {
      cov_2lmk0xa03k.s[24]++;

      return URLSERVER + 'UtilisateurPictures/';
    },
    post: function post(urlp, paramsp, callbacksuccess, callbackError) {
      cov_2lmk0xa03k.s[25]++;

      if (!callbacksuccess) {
        cov_2lmk0xa03k.b[0][0]++;
        cov_2lmk0xa03k.s[26]++;

        callbacksuccess = function callbacksuccess(data) {
          cov_2lmk0xa03k.f[1]++;
        };
      } else {
        cov_2lmk0xa03k.b[0][1]++;
      }
      cov_2lmk0xa03k.s[27]++;
      if (!callbackError) {
        cov_2lmk0xa03k.b[1][0]++;
        cov_2lmk0xa03k.s[28]++;

        callbackError = function callbackError(err) {
          cov_2lmk0xa03k.f[2]++;
        };
      } else {
        cov_2lmk0xa03k.b[1][1]++;
      }
      cov_2lmk0xa03k.s[29]++;
      if (!paramsp) {
        cov_2lmk0xa03k.b[2][0]++;
        cov_2lmk0xa03k.s[30]++;

        paramsp = {};
      } else {
        cov_2lmk0xa03k.b[2][1]++;
      }
      var path = (cov_2lmk0xa03k.s[31]++, ((cov_2lmk0xa03k.b[3][0]++, urlp) || (cov_2lmk0xa03k.b[3][1]++, '')).split('/'));
      cov_2lmk0xa03k.s[32]++;
      paramsp.li_bksb = path[path.length - 1];
      cov_2lmk0xa03k.s[33]++;
      paramsp.u_bksb = this.idUser;
      cov_2lmk0xa03k.s[34]++;
      paramsp.e_bksb = this.espace;
      cov_2lmk0xa03k.s[35]++;
      paramsp.p_bksb = this.projet;
      cov_2lmk0xa03k.s[36]++;
      paramsp.a_bksb = this.admin;

      cov_2lmk0xa03k.s[37]++;
      paramsp.now = Date.now();
      var deferred = (cov_2lmk0xa03k.s[38]++, $q.defer());
      cov_2lmk0xa03k.s[39]++;
      paramsp.method = 1;
      cov_2lmk0xa03k.s[40]++;
      $http.post('data/web_server.php', paramsp).then(function (response) {
        cov_2lmk0xa03k.f[3]++;

        var data = (cov_2lmk0xa03k.s[41]++, response.data);
        cov_2lmk0xa03k.s[42]++;
        if (data.error) {
          cov_2lmk0xa03k.b[4][0]++;
          cov_2lmk0xa03k.s[43]++;

          $location.path('/login');
          cov_2lmk0xa03k.s[44]++;
          return;
        } else {
          cov_2lmk0xa03k.b[4][1]++;
        }
        cov_2lmk0xa03k.s[45]++;
        callbacksuccess(data);
      }, function () {
        cov_2lmk0xa03k.f[4]++;
        cov_2lmk0xa03k.s[46]++;

        callbackError();
      });
      cov_2lmk0xa03k.s[47]++;
      return deferred.promise;
    },
    get: function get(urlp, paramsp, callbacksuccess, callbackError) {
      cov_2lmk0xa03k.s[48]++;

      if (!callbacksuccess) {
        cov_2lmk0xa03k.b[5][0]++;
        cov_2lmk0xa03k.s[49]++;

        callbacksuccess = function callbacksuccess(data) {
          cov_2lmk0xa03k.f[5]++;
        };
      } else {
        cov_2lmk0xa03k.b[5][1]++;
      }
      cov_2lmk0xa03k.s[50]++;
      if (!callbackError) {
        cov_2lmk0xa03k.b[6][0]++;
        cov_2lmk0xa03k.s[51]++;

        callbackError = function callbackError() {
          cov_2lmk0xa03k.f[6]++;
        };
      } else {
        cov_2lmk0xa03k.b[6][1]++;
      }
      cov_2lmk0xa03k.s[52]++;
      if (!paramsp) {
        cov_2lmk0xa03k.b[7][0]++;
        cov_2lmk0xa03k.s[53]++;

        paramsp = {};
      } else {
        cov_2lmk0xa03k.b[7][1]++;
      }
      var path = (cov_2lmk0xa03k.s[54]++, ((cov_2lmk0xa03k.b[8][0]++, urlp) || (cov_2lmk0xa03k.b[8][1]++, '')).split('/'));
      cov_2lmk0xa03k.s[55]++;
      paramsp.li_bksb = path[path.length - 1];
      cov_2lmk0xa03k.s[56]++;
      paramsp.u_bksb = this.idUser;
      cov_2lmk0xa03k.s[57]++;
      paramsp.e_bksb = this.espace;
      cov_2lmk0xa03k.s[58]++;
      paramsp.p_bksb = this.projet;
      cov_2lmk0xa03k.s[59]++;
      paramsp.a_bksb = this.admin;

      var deferred = (cov_2lmk0xa03k.s[60]++, $q.defer());
      cov_2lmk0xa03k.s[61]++;
      $http({
        method: 'GET',
        url: 'data/web_server.php',
        params: paramsp
      }).then(function (response) {
        cov_2lmk0xa03k.f[7]++;

        var data = (cov_2lmk0xa03k.s[62]++, response.data);
        cov_2lmk0xa03k.s[63]++;
        if (data.error) {
          cov_2lmk0xa03k.b[9][0]++;
          cov_2lmk0xa03k.s[64]++;

          $location.path('/login');
          cov_2lmk0xa03k.s[65]++;
          return;
        } else {
          cov_2lmk0xa03k.b[9][1]++;
        }
        cov_2lmk0xa03k.s[66]++;
        callbacksuccess(data);
      }, function () {
        cov_2lmk0xa03k.f[8]++;
        cov_2lmk0xa03k.s[67]++;

        callbackError();
      });
      cov_2lmk0xa03k.s[68]++;
      return deferred.promise;
    }
  };
}]).factory('$CRUDService', ['$deltahttp', function ($deltahttp) {
  cov_2lmk0xa03k.f[9]++;
  cov_2lmk0xa03k.s[69]++;

  return {
    getAll: function getAll(urlvar, params, success, error) {
      var base_url = (cov_2lmk0xa03k.s[70]++, URL + '/' + urlvar);
      cov_2lmk0xa03k.s[71]++;
      $deltahttp.ckeck = 0;
      cov_2lmk0xa03k.s[72]++;
      return $deltahttp.get(base_url, params, success, error);
    },
    save: function save(urlvar, e, success, error) {
      var base_url = (cov_2lmk0xa03k.s[73]++, URL + '/' + urlvar);
      cov_2lmk0xa03k.s[74]++;
      $deltahttp.ckeck = 0;
      cov_2lmk0xa03k.s[75]++;
      return $deltahttp.post(base_url, e, success, error);
    },
    update: function update(urlvar, e, success, error) {
      var base_url = (cov_2lmk0xa03k.s[76]++, URL + '/' + urlvar);
      cov_2lmk0xa03k.s[77]++;
      $deltahttp.ckeck = 0;
      cov_2lmk0xa03k.s[78]++;
      return $deltahttp.post(base_url, e, success, error);
    },
    // entreprises
    delet: function delet(urlvar, e, success, error) {
      var base_url = (cov_2lmk0xa03k.s[79]++, URL + '/' + urlvar);
      cov_2lmk0xa03k.s[80]++;
      $deltahttp.ckeck = 0;
      cov_2lmk0xa03k.s[81]++;
      return $deltahttp.post(base_url, e, success, error);
    },
    getServerAdress: function getServerAdress() {
      cov_2lmk0xa03k.s[82]++;

      return URL;
    },
    getComplement: function getComplement(index, path) {
      cov_2lmk0xa03k.s[83]++;

      if (index == 1) {
        cov_2lmk0xa03k.b[10][0]++;

        var paramsp = (cov_2lmk0xa03k.s[84]++, []);
        cov_2lmk0xa03k.s[85]++;
        paramsp.u_bksb = $deltahttp.idUser;
        cov_2lmk0xa03k.s[86]++;
        paramsp.e_bksb = $deltahttp.espace;
        cov_2lmk0xa03k.s[87]++;
        paramsp.p_bksb = $deltahttp.projet;
        cov_2lmk0xa03k.s[88]++;
        paramsp.a_bksb = $deltahttp.admin;
        cov_2lmk0xa03k.s[89]++;
        paramsp.li_bksb = path;
        cov_2lmk0xa03k.s[90]++;
        return paramsp;
      } else {
        cov_2lmk0xa03k.b[10][1]++;
      }

      cov_2lmk0xa03k.s[91]++;
      return 'u_bksb=' + $deltahttp.idUser + '&e_bksb=' + $deltahttp.espace + '&p_bksb=' + $deltahttp.projet + '&a_bksb=' + $deltahttp.admin + '&li_bksb=' + path;
    },
    getServerStrict: function getServerStrict() {
      cov_2lmk0xa03k.s[92]++;

      return URLSERVER;
    }
  };
}]).factory('$otherHttpService', ['$deltahttp', function ($deltahttp) {
  cov_2lmk0xa03k.f[10]++;
  cov_2lmk0xa03k.s[93]++;

  return {
    get: function get(urlvar, params, success, error) {
      var base_url = (cov_2lmk0xa03k.s[94]++, URL + '/' + urlvar);
      cov_2lmk0xa03k.s[95]++;
      $deltahttp.ckeck = 0;
      cov_2lmk0xa03k.s[96]++;
      return $deltahttp.get(base_url, params, success, error);
    },
    post: function post(urlvar, e, success, error) {
      var base_url = (cov_2lmk0xa03k.s[97]++, URL + '/' + urlvar);
      cov_2lmk0xa03k.s[98]++;
      $deltahttp.ckeck = 0;
      cov_2lmk0xa03k.s[99]++;
      return $deltahttp.post(base_url, e, success, error);
    }
  };
}]).factory('$LOGINService', ['$deltahttp', function ($deltahttp) {
  cov_2lmk0xa03k.f[11]++;
  cov_2lmk0xa03k.s[100]++;

  this.token_bksb = 'bk' + new Date().getTime() + 'sb';
  cov_2lmk0xa03k.s[101]++;
  return {
    setUE: function setUE(u, e) {
      cov_2lmk0xa03k.s[102]++;

      $deltahttp.setUE(u, e);
    },
    login: function login(e, success) {
      var base_url = (cov_2lmk0xa03k.s[103]++, URL + 'Connexion');
      var token = (cov_2lmk0xa03k.s[104]++, 'bk' + new Date().getTime() + 'sb');
      cov_2lmk0xa03k.s[105]++;
      if (window.localStorage) {
        cov_2lmk0xa03k.b[11][0]++;
        cov_2lmk0xa03k.s[106]++;

        token = localStorage.getItem('token_delta-se');
        cov_2lmk0xa03k.s[107]++;
        if (!token) {
          cov_2lmk0xa03k.b[12][0]++;
          cov_2lmk0xa03k.s[108]++;

          token = 'bk' + new Date().getTime() + 'sb';
          cov_2lmk0xa03k.s[109]++;
          localStorage.setItem('token_delta-se', token);
        } else {
          cov_2lmk0xa03k.b[12][1]++;
        }
      } else {
        cov_2lmk0xa03k.b[11][1]++;
      }
      cov_2lmk0xa03k.s[110]++;
      this.token_bksb = token;
      cov_2lmk0xa03k.s[111]++;
      e.action = 'l';
      cov_2lmk0xa03k.s[112]++;
      e.t_bksb = this.token_bksb;
      cov_2lmk0xa03k.s[113]++;
      return $deltahttp.post(base_url, e, success);
    },
    checkLogin: function checkLogin(e, success, error) {
      var base_url = (cov_2lmk0xa03k.s[114]++, URL + 'Connexion');
      cov_2lmk0xa03k.s[115]++;
      if (!e) {
        cov_2lmk0xa03k.b[13][0]++;
        cov_2lmk0xa03k.s[116]++;

        e = {};
      } else {
        cov_2lmk0xa03k.b[13][1]++;
      }

      cov_2lmk0xa03k.s[117]++;
      e.get = 'state';
      cov_2lmk0xa03k.s[118]++;
      e.t_bksb = this.token_bksb;
      cov_2lmk0xa03k.s[119]++;
      $deltahttp.get(base_url, e, success, error);
    },
    logout: function logout(e, success) {
      var base_url = (cov_2lmk0xa03k.s[120]++, URL + 'Connexion');
      cov_2lmk0xa03k.s[121]++;
      if (!e) {
        cov_2lmk0xa03k.b[14][0]++;
        cov_2lmk0xa03k.s[122]++;

        e = {};
      } else {
        cov_2lmk0xa03k.b[14][1]++;
      }
      cov_2lmk0xa03k.s[123]++;
      e.action = 'logout';
      cov_2lmk0xa03k.s[124]++;
      $deltahttp.post(base_url, e, success);
    }
  };
}]);